export default "__VITE_ASSET__CSy$Dy4r__"